import React from "react";
import SectionTitle from './section-title'
import "./book-page.m.css";

const upcomingBooks = [
  "y11ymohg/good-things-.png",
  "cc73i5ia/take-.png",
  "24gxxqx1/time-.png",
];

export default function UpcomingBookBlocks() {
  return (
    <section styleName="upcoming-books">
      <SectionTitle
        title="Upcoming Books:"
        width="14%"
      />

      <div styleName="upcoming-books-grid">
        {upcomingBooks.map((img, index) => (
          <div key={index} styleName="upcoming-book-card">
            <img
              loading="lazy"
              src={`https://images.assettype.com/newslaundry/2026-06-19/${img}`}
              alt=""
              styleName="upcoming-book-image"
            />
          </div>
        ))}
      </div>
    </section>
  );
}